<template>
    <div>
        <div style="height: 20vh;" class="inapp-hide"></div>
        <Riassunto :iscrizione="false" />
        <b-modal size="lg" ref="modal_team" class="text-dark modal__race" lazy hide-footer>
            <div class="text-left w-100">
                <div class="text-primary h3 font-weight-bold m-0 mt-2 mb-3 pl-3">Riepilogo creazione team</div>
            </div>
            <div>
                <div class="modal_race__items--wrapper__item__data p-1 text-dark">
                    <div class="px-2">
                        <div class="d-flex align-items-start justify-content-between border-bottom small p-2 mb-1">
                            <div class="small text-uppercase text-primary font-weight-bold">Team</div>
                            <div class="text-right">
                                <div class="small text-uppercase text-dark font-weight-bold">{{ form.nome_team }}</div>
                                <div>{{ tipo_team }}</div>
                                <div>Tipologia: {{ tipologia_team }}</div>
                                <div>{{ form.team_pass }}</div>
                                <div>{{ form.team_limit }}</div>
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-between border-bottom small p-2 mb-1">
                            <div class="small text-uppercase text-primary font-weight-bold">Referente</div>
                            <div class="text-right">
                                <div class="text-dark font-weight-bold">{{ form.ref_nome }}</div>
                                <div>{{ form.ref_email }}</div>
                                <div>{{ form.ref_telefono }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-2 w-100 mt-6 d-flex align-items-center justify-content-between">
                    <div class="btn-race secondary btn-sm"
                         @click="chiudi_modale">Modifica
                    </div>
                    <div class="btn-race btn-sm loader"
                         @click="submit" :disabled="submit_loader">
                        <span v-if="submit_loader"><img src="/static/svg/loader.svg" height="20"></span>
                        <span class="ml-1">Conferma</span>
                    </div>

                </div>
            </div>
        </b-modal>
        <div class="race-app-header inapp-show"></div>
        <div class="v-step step" v-bind:class="{ 'active': step === 0 }"
             @click="focusStep"
             @keyup.enter.stop="next(step_ok_team)"
        >
            <!-- Todo: la classe 'loading' non funziona -->
            <b-form-group  label="Scegli il nome della tua squadra">
                <b-input type="text"
                         v-model="form.nome_team"
                         :state="state('nome_team')"
                         placeholder="Nome del team"
                         autocomplete="nope"
                         @input="changeNomeTeam"
                         :class="{loading: team_status === 'loading'}"
                         data-vv-name="nome_team"
                         data-vv-as="nome del team"
                         v-validate="'required|min:3|max:30'"
                         key="nome-team"
                         required></b-input>
                <!-- Todo: qui manca probabilmente qualche classe -->
                <span v-show="errors.has('nome_team')">{{ errors.first('nome_team') }}</span>
            </b-form-group>

            <!-- Todo: evidenziare meglio qui -->
            <div class="help" v-if="team_status === 'duplicate'">
                Esiste già un team con questo nome, scegli un nuovo nome!<br>
                O chiedi di partecipare al team leader!
            </div>

            <div class="v-step__footer-step">
                <b-button :disabled="!step_ok_team" @click="next">Ok</b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>


        <div class="v-step step" v-bind:class="{ 'active': step === 1 }"
             @click="focusStep"
             @keyup.enter.stop="next(step_ok_referente)"
        >
            <b-form-group label="Qualche dato sul referente squadra">
                <b-input-group class="bg-transparent text-dark" append="Email">
                    <b-input type="email"
                             v-model="form.ref_email"
                             :state="state('ref_email')"
                             @input="changeEmail"
                             required
                             placeholder="Inserisci email"
                             data-vv-as="e-mail referente"
                             data-vv-name="ref_email"
                             key="ref_email"
                             v-validate="'required|email'"
                             :class="{loading: email_status === 'loading'}"
                    ></b-input>
                </b-input-group>
                <span v-show="errors.has('ref_email')"
                      class="error">{{ errors.first('ref_email') }}</span>
                <!-- Todo: dare la giusta rilevanza ai seguenti messaggi -->
                <span v-if="email_status === 'already-in-team'">
                    L'e-mail è già stata utilizzata per la creazione di un altro team, esci dall'altro team prima di poterne creare uno nuovo
                </span>
                <span v-if="email_status === 'present'">
                    Abbiamo già i tuoi dati in quanto ti sei già iscritto alla race, prosegui pure
                </span>
                <!-- Todo: va bene se inserisco tutto in uno span ? -->
                <span v-if="email_status === 'notpresent'">
                    <!-- Todo: non conviene usare una sola classe al postro di queste 3 per evitare casini? -->
                    <b-input-group class="bg-transparent text-dark" append="Nome">
                        <!-- Todo: non è molto responsive il placeholder -->
                        <b-input v-model="form.ref_nome"
                                 :state="state('ref_nome')"
                                 required
                                 placeholder="Inserisci il nome"
                                 autocomplete="nope"
                                 data-vv-name="ref_nome"
                                 data-vv-as="nome referente"
                                 key="ref_nome"
                                 v-validate="'required|name'"
                        ></b-input>
                    </b-input-group>
                        <span v-show="errors.has('ref_nome')"
                              class="error">{{ errors.first('ref_nome') }}</span>

                    <b-input-group class="bg-transparent text-dark" append="Cognome">
                        <b-input v-model="form.ref_cognome"
                                 :state="state('ref_cognome')"
                                 required
                                 placeholder="Inserisci il cognome"
                                 autocomplete="nope"
                                 data-vv-name="ref_cognome"
                                 key="ref_cognome"
                                 data-vv-as="cognome referente"
                                 v-validate="'required|name'"
                        ></b-input>
                    </b-input-group>
                        <span v-show="errors.has('ref_cognome')"
                              class="error">{{ errors.first('ref_cognome') }}</span>

                </span>
                <b-input-group class="bg-transparent text-dark" append="Telefono"
                               v-if="email_status === 'notpresent' || email_status === 'phone-missing'">
                    <b-input v-model="form.ref_telefono"
                             :state="state('ref_telefono')"
                             required
                             placeholder="Numero di telefono"
                             autocomplete="nope"
                             data-vv-name="ref_telefono"
                             key="ref_telefono"
                             v-validate="'required|phone'"
                             data-vv-as="telefono referente"
                             :formatter="phone_format"
                    ></b-input>
                </b-input-group>
                <!-- Todo: questi span possono rimanere nell'input group o fa casino? per tenere tutto un po' più pulito e organizzato -->
                <span v-show="errors.has('ref_telefono')"
                      class="error">{{ errors.first('ref_telefono') }}</span>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!step_ok_referente" @click="next">Ok</b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>


        <div class="v-step step"
             v-bind:class="{ 'active': step === 2 }"
             @click="focusStep"
             @keyup.enter.stop="next(step_ok_capitano)"
        >
            <b-form-group label="Il referente e il capitano della squadra coincidono?"
            >
                <b-form-radio-group v-model="form.ref_uguale_capitano" name="categoria">
                    <b-form-radio value="si"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Sì, sono la stessa persona
                    </b-form-radio>
                    <b-form-radio value="no"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        No, sono due persone diverse
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <!-- Todo: dare lo stile da sottodomanda -->
            <b-form-group label="Qualche dato del capitano" class="v-substep"
                          v-show="form.ref_uguale_capitano === 'no'">
                <b-input v-model="form.cap_nome"
                         :state="state('cap_nome')"
                         required
                         placeholder="Nome capitano"
                         autocomplete="nope"
                         data-vv-name="cap_nome"
                         data-vv-as="nome capitano"
                         v-validate="'required|name|min:2'"
                         key="cap_nome"
                ></b-input>
                <span v-show="errors.has('cap_nome')"
                      class="error">{{ errors.first('cap_nome') }}</span>

                <b-input v-model="form.cap_cognome"
                         :state="state('cap_cognome')"
                         required
                         placeholder="Cognome capitano"
                         autocomplete="nope"
                         data-vv-as="cognome capitano"
                         data-vv-name="cap_cognome"
                         @keyup.native.enter.stop="next"
                         v-validate="'required|name'"
                         key="cap_cognome"
                ></b-input>
                <span v-show="errors.has('cap_cognome')"
                      class="error">{{ errors.first('cap_cognome') }}</span>

            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!step_ok_capitano" @click="next">Ok</b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <div class="v-step step"
             v-bind:class="{ 'active': step === 3 }"
             @click="focusStep"
             @keyup.enter.stop="next(step_ok_tiplogia)"
        >
            <b-form-group label="Che tipo di squadra vuoi creare?"
            >
                <b-form-radio-group v-model="form.team_tipologia" name="tiplogia">
                    <b-form-radio value="istituzione-associazione"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Istituzione / Associazione
                    </b-form-radio>
                    <b-form-radio value="aziendale"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Aziendale
                    </b-form-radio>
                    <b-form-radio value="altro"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Altro
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <div class="v-step__footer-step">
                <b-button :disabled="!step_ok_tiplogia" @click="next">Ok</b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>


        <div class="v-step step"
             v-bind:class="{ 'active': step === 4 }"
             @click="focusStep"
             @keyup.enter.stop="next(step_ok_type)"
        >
            <b-form-group label="Molto bene! Desideri limitare il numero di iscritti?"
            >
                <b-form-radio-group v-model="form.team_type" name="categoria">
                    <b-form-radio value="gruppo-aperto"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Gruppo aperto - Senza limite
                    </b-form-radio>
                    <b-form-radio value="gruppo-aperto-limitato"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Gruppo aperto - Con limite di persone
                    </b-form-radio>
                    <b-form-radio value="gruppo-chiuso"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Gruppo chiuso - Iscrivo io / utilizzando una password
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-form-group label="Vuoi inserire una password?"
                          v-show="form.team_type === 'gruppo-chiuso'"
                          class="v-substep">
                <b-input v-model="form.team_pass"
                         :state="state('team_pass')"
                         required
                         placeholder="Password per la squadra"
                         data-vv-name="team_pass"
                         data-vv-as="password"
                         v-validate="'min:4'"
                         key="team_pass"
                ></b-input>
                <span v-show="errors.has('team_pass')"
                      class="error">{{ errors.first('team_pass') }}</span>

            </b-form-group>

            <b-form-group label="Imposta un limite massimo di iscritti"
                          v-show="form.team_type === 'gruppo-aperto-limitato'"
                          class="v-substep">
                <b-input v-model="form.team_limit"
                         :state="state('team_limit')"
                         required
                         placeholder="es: 100"
                         data-vv-name="team_limit"
                         data-vv-as="limite partecipanti"
                         v-validate="'min_value:5|required'"
                         key="team_limit"
                ></b-input>
                <span v-show="errors.has('team_limit')"
                      class="error">{{ errors.first('team_limit') }}</span>

            </b-form-group>

            <!-- Todo: manca il submit loader -->
            <div class="v-step__footer-step">
                <b-button :disabled="!step_ok_type" variant="primary"
                          @click="show_modale">
                    Crea il tuo team
                </b-button>
            </div>
        </div>
        <div style="height: 30vh;"></div>
    </div>
</template>

<script>
    import BaseForm from "../BaseForm";
    import debounce from 'lodash/debounce'
    import Riassunto from "./Riassunto";

    export default {
        name: "CreazioneTeam",
        extends: BaseForm,
        components: {Riassunto},
        async mounted() {
            await this.$nextTick()
            this.form.id_race = this.$store.state.id_race
        },
        data() {
            return {
                form: {
                    type: 'CreazioneTeam',
                    nome_team: null,
                    ref_email: null,
                    ref_nome: null,
                    ref_cognome: null,
                    ref_telefono: null,
                    ref_uguale_capitano: null,
                    cap_nome: null,
                    cap_cognome: null,
                    team_type: null,
                    team_pass: null,
                    team_limit: null,
                    team_tipologia: null,
                    scelta: null,
                    id_race: null
                },
                team_status: false,
                email_status: null,
                submit_loader: false,
            }
        }, methods: {
            submit() {
                this.submit_loader = true;
                this.$store.dispatch({
                    type: 'submit',
                    data: this.form,
                    id_form: this.id_form,
                    url: '/race/form/creazione_team',
                    retry: 1
                }).then((response) => {
                    this.submit_loader = false
                    this.$notify({text: this.form.nome_team + ' team creato con successo!', duration: 10})
                    this.$store.commit('team', {
                        name: this.form.nome_team,
                        id: response.data.id,
                        type: this.form.team_type
                    })
                    this.$store.commit('payer_id', response.data.payer_id)
                    this.$store.commit('default_data', {
                        nome: this.form.ref_nome,
                        cognome: this.form.ref_cognome,
                        email: this.form.ref_email,
                        phone: this.form.ref_telefono
                    })
                    this.chiudi_modale()
                    this.goTo('team-creato')
                }, () => {
                    this.submit_loader = false
                })
            },
            changeEmail: debounce(function () {
                if (!this.compiled('ref_email')) {
                    this.email_status = null;
                    return false;
                }
                // Se la mail è stata compilata, posso fare la chiamata ajax
                this.email_status = 'loading';
                this.$http.get('/race/form/creazione_team/?type=email&email=' + this.form.ref_email + '&id_race=' + this.id_race).then((response) => {
                    this.email_status = response.data.state;
                })
            }, 100),
            changeNomeTeam: debounce(function () {
                if (!this.compiled('nome_team')) {
                    this.team_status = null;
                    return false;
                }
                // Se il nome è stato compilato, posso fare la chiamata ajax
                this.team_status = 'loading';
                this.$http.get('/race/form/creazione_team/?type=nome_team&nome=' + this.form.nome_team + '&id_race=' + this.id_race).then((response) => {
                    this.team_status = response.data.state;
                })
            }, 200),
            show_modale() {
                this.$refs.modal_team.show()
            }, chiudi_modale() {
                this.$refs.modal_team.hide()
            }
        }, computed: {
            step_ok_team() {
                if (!this.compiled('nome_team')) return false
                if (this.team_status === null) return false
                if (this.team_status === 'loading') return false
                if (this.team_status === 'duplicate') return false
                return true
            }, step_ok_capitano() {
                if (this.form.ref_uguale_capitano === null) return false
                if (this.form.ref_uguale_capitano === 'no') return this.compiled('cap_nome', 'cap_cognome')
                return true
            }, step_ok_type() {
                if (this.form.team_type === null) return false
                if (this.form.team_type === 'gruppo-aperto-limitato') return this.compiled('team_limit')
                if (this.form.team_type === 'gruppo-chiuso') return this.compiled('team_pass')
                return true
            }, step_ok_tiplogia() {
                if (this.form.team_tipologia === null) return false
                return true
            }, id_race() {
                return this.$store.state.id_race
            }, step_ok_referente() {
                if (!this.compiled('ref_email')) return false
                if (this.email_status === null || this.email_status === 'loading') return false
                if (this.email_status === 'already-in-team') return false
                if (this.email_status === 'present') return true

                if (this.email_status === 'phone-missing')
                    return this.compiled('ref_telefono')

                if (!this.compiled('ref_nome')) return false
                if (!this.compiled('ref_cognome')) return false
                if (!this.compiled('ref_telefono')) return false
                return true
            }, tipo_team() {
                if (this.form.team_type === 'gruppo-aperto') return 'Gruppo aperto'
                if (this.form.team_type === 'gruppo-chiuso') return 'Gruppo chiuso'
                if (this.form.team_type === 'gruppo-aperto-limitato') return 'Gruppo aperto limitato'
                return 'N/D'
            }, tipologia_team() {
                if (this.form.team_tipologia === 'altro') return 'Altro'
                if (this.form.team_tipologia === 'aziendale') return 'Aziendale'
                if (this.form.team_tipologia === 'istituzione-associazione') return 'Istituzione / Associazione'
                return 'N/D'
            }
        }
    }
</script>

<style scoped>

</style>
